import { render } from "./AssistantLauncher.vue?vue&type=template&id=66363766&scoped=true"
import script from "./AssistantLauncher.vue?vue&type=script&lang=js"
export * from "./AssistantLauncher.vue?vue&type=script&lang=js"

import "./AssistantLauncher.vue?vue&type=style&index=0&id=66363766&scoped=true&lang=css"
import "./AssistantLauncher.vue?vue&type=style&index=1&id=66363766&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66363766"]])

export default __exports__